/* eslint-disable no-console */
import { addColorSwap, updateActiveColor } from './color-swap';
import { addSingleProductDealerShareModal } from '../dealer-contact/single-product-dealer-share-modal';
import { setupCartActions, updateCartState } from '../cart-helpers';

import SiteModal from '../site-modal';
import SwatchOrderingUtils from '../swatch-ordering';

let selectedFilters = [];

const updateSwatchesModal = (options) => {
  const {
    photos,
    selectedColorName,
  } = options;
  const modalDiv = document.querySelector('.product-swatches-modal');
  // Set color name
  const colorNameDiv = modalDiv.querySelector('.selected-colorname');
  colorNameDiv.innerHTML = selectedColorName;
  // Set product preview image
  if (photos.primaryImage) {
    const productPreviewImg = modalDiv.querySelector('.selected-color-product-preview');
    productPreviewImg.srcset = photos.primaryImage.url;
    productPreviewImg.setAttribute('data-src', photos.primaryImage.url);
    productPreviewImg.setAttribute('alt', photos.primaryImage.alt);
  }
  // Update selected color
  updateActiveColor({
    btn: modalDiv.querySelector(`.swatch-image[data-colorname="${selectedColorName}"]`),
    swatchList: modalDiv,
  });
};

const filterSwatches = () => {
  const list = document.querySelectorAll('.swatch-list-item');
  const filters = document.querySelectorAll('.filter-checkbox');
  if (selectedFilters.length === 0) {
    list.forEach((n) => { n.hidden = false; });
    filters.forEach((f) => { f.checked = false; });
    return;
  }

  list.forEach((n) => {
    const colorRange = n.getAttribute('data-colorrange');
    n.hidden = !selectedFilters.includes(colorRange);
  });
};

const setupSwatchFiltering = () => {
  const filters = document.querySelectorAll('.filter-checkbox');
  filters.forEach((f) => {
    f.onchange = (e) => {
      const colorRange = e.target.getAttribute('data-query-value');
      if (e.target.checked) {
        selectedFilters.push(colorRange);
      } else {
        selectedFilters = selectedFilters.filter(s => s !== colorRange);
      }
      filterSwatches();
    };
  });
};

const addSwatchesModal = (options) => {
  const { onUpdate } = options;
  // Init modal
  const modal = new SiteModal({
    id: 'product-swatches-modal',
    callbacks: {
      onOpen: () => {
        updateCartState();
        selectedFilters = [];
        filterSwatches();
        setupSwatchFiltering();
      },
    },
  });
  // Add event listeners to all buttons that trigger the modal
  [].map.call(document.querySelectorAll('.swatches-modal-btn'), menuItem => (
    menuItem.addEventListener('click', () => {
      modal.open();
    })
  ));
  // Init swatch ordering utils
  SwatchOrderingUtils();
  addSingleProductDealerShareModal();
  // Init color w/in modal
  addColorSwap({
    btnSelector: '.swatch-image',
    groupSelector: '.product-swatches-modal',
    onUpdate,
  });
  setupCartActions();
};

export {
  addSwatchesModal,
  updateSwatchesModal,
};
/* eslint-enable no-console */
